<template>
    <div>

        <div class="content-header text-center">
            <h2>Select a Plan</h2>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col text-center">
                    <h3>Purchase Email Append Credits</h3>
                    <p class="lead">You currently have {{this.userSubscription.email}} credits remaining.</p>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <h5 class="card-title">100 Email Append Credits</h5>
                            <h3 class="card-text lead text-center text-success"><strong>$5.00</strong></h3>
                            <hr>
                            <p class="card-text"></p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseEmail', {title: 'Analyze360 Email Append 100 credits', price: '5', sku: 'A360_100_CREDITS_5', mode: 'payment', credits: '100' })">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <h5 class="card-title">1000 Email Append Credits</h5>
                            <h3 class="card-text lead text-center text-success"><strong>$50.00</strong></h3>
                            <hr>
                            <p class="card-text"></p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseEmail', {title: 'Analyze360 Email Append 1000 credits', price: '50', sku: 'A360_1000_CREDITS_50', mode: 'payment', credits: '1000' })">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <h5 class="card-title">5000 Email Append Credits</h5>
                            <h3 class="card-text lead text-center text-success"><strong>$250.00</strong></h3>
                            <hr>
                            <p class="card-text"></p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseEmail', {title: 'Analyze360 Email Append 5000 credits', price: '250', sku: 'price_1Pg5FW2IT6Xym7HTyMvMKtfI', mode: 'payment', credits: '5000' })">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <h5 class="card-title">10000 Email Append Credits</h5>
                            <h3 class="card-text lead text-center text-success"><strong>$500.00</strong></h3>
                            <hr>
                            <p class="card-text"></p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseEmail', {title: 'Analyze360 Email Append 10000 credits', price: '500', sku: 'A360_10000_CREDITS_500', mode: 'payment', credits: '10000' })">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <h5 class="card-title">20000 Email Append Credits</h5>
                            <h3 class="card-text lead text-center text-success"><strong>$1000.00</strong></h3>
                            <hr>
                            <p class="card-text"></p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseEmail', {title: 'Analyze360 Email Append 20000 credits', price: '1000', sku: 'A360_20000_CREDITS_1000', mode: 'payment', credits: '20000' })">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <h5 class="card-title">50000 Email Append Credits</h5>
                            <h3 class="card-text lead text-center text-success"><strong>$2500.00</strong></h3>
                            <hr>
                            <p class="card-text"></p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseEmail', {title: 'Analyze360 Email Append 500000 credits', price: '2500', sku: 'A360_50000_CREDITS_2500', mode: 'payment', credits: '50000' })">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    name: 'SelectEmailAppend',
    props: {
        userSubscription: []
    },
    mounted() {
    }
}
</script>